/*
 * Copyright (c) 2024, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

import LoginFields from '@salesforce/retail-react-app/app/components/forms/login-fields';
import {Button, Stack, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';
import SocialLogin from '@salesforce/retail-react-app/app/components/social-login';

const StandardLogin = ({
  form,
  handleForgotPasswordClick,
  hideEmail = false,
  isSocialEnabled = false,
  setShowPasswordView,
  idps = [],
}) => {
  const styles = useMultiStyleConfig('FormAuth', {});

  return (
    <Stack gap={0}>
      <LoginFields
        form={form}
        handleForgotPasswordClick={handleForgotPasswordClick}
        hideEmail={hideEmail}
      />
      <Stack {...styles.buttonContainer}>
        <Button
          isLoading={form.formState.isSubmitting}
          type="submit"
          onClick={() => {
            form.clearErrors('global');
          }}
          {...styles.buttonSubmit}
        >
          <FormattedMessage defaultMessage="Sign In" id="login_form.button.sign_in" />
        </Button>
        {isSocialEnabled && idps.length > 0 && (
          <>
            <Text {...styles.divider}>
              <FormattedMessage
                defaultMessage="Or continue with"
                id="login_page.or_continue_with"
              />
            </Text>
            <SocialLogin form={form} idps={idps} />
          </>
        )}
        {hideEmail && (
          <Button
            {...styles.buttonOutline}
            onClick={() => setShowPasswordView(false)}
          >
            <FormattedMessage
              defaultMessage="Back to Sign In Options"
              id="login_form.button.back"
            />
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

StandardLogin.propTypes = {
  form: PropTypes.object,
  handleForgotPasswordClick: PropTypes.func,
  hideEmail: PropTypes.bool,
  isSocialEnabled: PropTypes.bool,
  setShowPasswordView: PropTypes.func,
  idps: PropTypes.arrayOf(PropTypes.string),
};

export default StandardLogin;
